<!-- dynamic-chart.component.html -->
<canvas #thisChart baseChart
        [data]="chartData"
        [options]="chartOptions"
        [type]="barChartType">
</canvas>
